'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import PromotionBannerContainer from 'pricing-pages-unified-ui/components/banners/PromotionBannerContainer';
import PartnerProgramBanner from 'pricing-pages-unified-ui/components/banners/PartnerProgramBanner';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import ActiveQuoteBanner from './ActiveQuoteBanner';
import EnvironmentWrapper from 'pricing-pages-unified-ui/components/EnvironmentWrapper';
import MarketingBasicPromoBanner from './MarketingBasicPromoBanner';
import styled from 'styled-components';
import FintechFireAlarmBanner from '../common/FintechFireAlarmBanner';
import BannerHierarchySection from './BannerHierarchySection';
import { MARKETING } from 'self-service-api/constants/ProductLines';
import MarketingHubEntPriceChangeBanner from './MarketingHubEntPriceChangeBanner';
import { getMarketingHubEntIncreaseAnnouncementIsActive } from 'pricing-pages-lib/utils/offerUtils';
const PromotionGrid = styled.div.withConfig({
  displayName: "BannerSection__PromotionGrid",
  componentId: "sc-4u0466-0"
})(["display:grid;grid-auto-rows:auto;grid-row-gap:16px;&:not(:empty){margin-bottom:16px;}"]);

const BannerSection = (_ref) => {
  let {
    productLine,
    screen
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["productLine", "screen"]);

  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const marketingHubIncreaseAnnouncementIsActive = getMarketingHubEntIncreaseAnnouncementIsActive();
  const shouldShowMarketingHubPriceIncreaseBanner = marketingHubIncreaseAnnouncementIsActive && productLine === MARKETING;
  return /*#__PURE__*/_jsxs(PromotionGrid, Object.assign({}, rest, {
    children: [/*#__PURE__*/_jsx(FintechFireAlarmBanner, {}), /*#__PURE__*/_jsx(PromotionBannerContainer, {
      productLine: productLine
    }), /*#__PURE__*/_jsx(EnvironmentWrapper, {
      authedNode: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(BannerHierarchySection, {
          screen: screen
        }), /*#__PURE__*/_jsx(PartnerProgramBanner, {}), /*#__PURE__*/_jsx(ActiveQuoteBanner, {
          productLine: productLine,
          screen: screen
        }), hasPricingAndPurchasingSucceeded && shouldShowMarketingHubPriceIncreaseBanner && /*#__PURE__*/_jsx(MarketingHubEntPriceChangeBanner, {}), hasPricingAndPurchasingSucceeded && /*#__PURE__*/_jsx(MarketingBasicPromoBanner, {
          productLine: productLine
        })]
      }),
      publicNode: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(BannerHierarchySection, {
          screen: screen
        }), hasPricingAndPurchasingSucceeded && shouldShowMarketingHubPriceIncreaseBanner && /*#__PURE__*/_jsx(MarketingHubEntPriceChangeBanner, {})]
      })
    })]
  }));
};

BannerSection.propTypes = {
  productLine: PropTypes.string.isRequired,
  screen: PropTypes.string.isRequired
};
export default BannerSection;